// Internal modules
import { appStore } from '@/store';
import { apolloMutation } from '@/lib/apollo';
import { $logger, getToken, redirectToGenericError } from '@/lib';
import { UPDATE_CALLBACK_OPTIONS_MUTATION } from '../mutations/updateCallbackOptions';
import { mapCallbackShippingMethodsInput } from '../lenses/mapCallbackShippingMethodsInput';

const updateCallbackOptions = () => {
  const { api: apiState } = appStore.getState();
  const { shippingMethods, shippingOptionsSource } = apiState;

  if (!shippingMethods.length) {
    return;
  }

  const variables = {
    callbackShippingMethods: mapCallbackShippingMethodsInput(shippingMethods),
    shippingOptionsSource,
    token: getToken(),
  };
  return apolloMutation({
    mutation: UPDATE_CALLBACK_OPTIONS_MUTATION,
    variables,
  })
    .then(({ data }) => {
      const { api: apiState } = appStore.getState();
      const { cartDetails } = apiState;
      const { api: apiActions } = appStore.getActions();
      const { setCartData } = apiActions;
      const { amounts } = data.updateCallbackOptions.cart;

      setCartData({
        cartAmount: amounts.total,
        cartDetails: {
          // Need to spread old values or else everything else in cartDetails
          // would be overwritten
          ...cartDetails,
          amounts,
        },
      });
      return data;
    })
    .catch(error => {
      $logger.error('snt_patch_cart_error', { error });
      redirectToGenericError();
    });
};

export { updateCallbackOptions };
